<template>
  <div>
    <popup2 v-model="showPopup" width="428" @click:outside="handleClose">
      <default-confirmation
        v-if="typeAction === 'delete'"
        @close="handleClose"
        text-delete="Delete this user completely?"
        @delete="deleteEntity"
      />
      <template v-else-if="typeAction === 'edit-rights'">
        <v-card>
          <v-card-title class="primary--text pa-4">
            Edit rights
          </v-card-title>
          <v-select
            :menu-props="{ bottom: true, offsetY: true }"
            v-model="popupValue"
            item-value="id"
            item-text="name"
            :items="getRights()"
            return-object
            class="px-4"
          ></v-select>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="handleClose">Cancel</v-btn>
            <v-btn color="primary" text @click="changeRights">Apply</v-btn>
          </v-card-actions>
        </v-card>
      </template>
      <link-object
        :loading="popupLoading"
        @close="handleClose"
        @save="connectObjectToUser"
        type-connection="objectToUser"
        v-else-if="typeAction === 'add-object'"
      ></link-object>
      <link-profile
        :user="userObject"
        @close="handleClose"
        v-else-if="typeAction === 'add-profile'"
        :type="userObject.type"
        :user-name="entity.title"
      />
      <edit-password
        :user-id="userObject.id"
        @close="handleClose"
        v-else-if="typeAction === 'change-password'"
      ></edit-password>
      <edit-rights-group
        v-else-if="typeAction === 'change-group-access'"
        :entity="userObject"
        :loading="popupLoading"
        @save="changeGroupRights"
        @close="handleClose"
      />
    </popup2>

    <portal-target name="user-portal">
      <app-entity
        :current-show="currentShow"
        :entity="entity"
        :loading="loading"
        :nested-entity="nestedEntity"
        :tab-data="logsList"
        @close-card="closeCard"
        @action="handleAction"
        @show-nested-entity="showNestedEntity"
        @close-history="currentShow = 'entity'"
        @close-nested-card="closeNestedCard"
        @show-full-logs="showFullLogs"
      />
    </portal-target>
  </div>
</template>

<script>
import useObject from '@/api/users/useUser';
import { onMounted } from '@vue/composition-api';
import DefaultConfirmation from '@/components/app-entity/modals/DefaultConfirmation';
import LinkProfile from '@/components/app-entity/modals/LinkProfile';

export default {
  name: 'ObjectItem',
  props: ['id'],
  components: {
    LinkProfile,
    DefaultConfirmation,
    EditUser: () => import('@/components/app-entity/modals/CreateUser.vue'),
    SendNoty: () => import('@/components/app-entity/modals/SendNoty'),
    LinkObject: () => import('@/components/app-entity/modals/LinkObject'),
    EditPassword: () => import('@/components/app-entity/modals/EditPassword'),
    EditRightsGroup: () =>
      import('@/components/app-entity/modals/EditRightsGroup')
  },
  setup(props, context) {
    const entityComposition = useObject(props, context);

    const closeCard = () => {
      entityComposition.closeNestedCard();
      entityComposition.entity.value = null;
      context.root.$router.push({
        name: 'users',
        query: context.root.$route.query
      });
    };

    onMounted(() => {
      entityComposition.closeNestedCard();
      entityComposition.load();
      entityComposition.subscribeToUpdate();
    });

    return {
      ...entityComposition,
      closeCard
    };
  }
};
</script>
